import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
import { TYPOGRAPHY } from "@store/theme/design";

Object.assign(buttonSizeVariants, {
    small: {
        height: 32,
        fontSize: TYPOGRAPHY.size.smallest,
        padding: "5px 15px",
        icon: 16,
        iconPadding: 6,
    },
    medium: {
        height: 40,
        fontSize: TYPOGRAPHY.size.smaller,
        padding: "8px 20px",
        icon: 21,
        iconPadding: 8,
    },
    large: {
        height: 48,
        fontSize: TYPOGRAPHY.size.smaller,
        padding: "12px 30px",
        icon: 25,
        iconPadding: 9,
    },
});
